class PaymentArrangement {
  constructor(params) {
    this.statusId = params.status.id;
  }
}

export { PaymentArrangement as default };
